import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import LoginForm from './LoginToolsForm';
import LoadMask from "Utils/LoadMask/LoadMask";
import { NotificationManager } from "react-notifications";

class LoginTools extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    componentDidMount() {
        setTimeout(() => {
            if (localStorage.getItem('session_expired_flash') === 'true') {
                
                if (NotificationManager) {
                    NotificationManager.listNotify = [];
                    NotificationManager.emitChange();
                }

                localStorage.removeItem('session_expired_flash');

                setTimeout(() => {
                    const container = document.querySelector('.notification-container');
                    if (container) {
                        container.style.display = '';
                    }
                    NotificationManager.warning(
                        "Su sesión ha expirado por inactividad. Por favor, ingrese de nuevo",
                        "Sesión Expirada",
                        8000
                    );
                }, 500);
            }
        }, 1000);
    }
    
    render() {
        const { loginTools, loader } = this.props;
        
        if (localStorage.getItem('tokenT')) {
            return (<Redirect to="/tools/home" />);
        }
        
        return (
            <div className="blue-gradient-bg">
                <div className="d-flex flex-column align-items-center pt-3 bienvenida title">
                    <img className="mt-5 imageReg"
                        src={require('assets/img/SIFW-LOGO-Red.png')}
                        alt="Logo" /> 
                </div>
                <br />
                <div className="login-wrapper">
                    <div className="card2 card border-0 px-4 py-5 bg-dark col-lg-6 col-md-4 col-11">
                        <h5 className="text-center pv mb-4 title">Iniciar sesión</h5>
                        <LoadMask loading={loader} dark>
                            <LoginForm onSubmit={loginTools} />
                        </LoadMask>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginTools;
